<h3 class="centered-text-block-content video-playback-error-msg" [hidden]="accountLicense.mediaViewingAllowed">
	<span class="glyphicons warning_sign"></span>
	{{ 'Video_Playback_ViewingHoursNotAvailable' | translate }}
</h3>

<div class="height-full" layout="column" [ngClass]="{ 'has-playlist': playlist?.id }">
	<div layout="row" flex="fill" *ngIf="accountLicense.mediaViewingAllowed && !isVideoUnavailable">
		<!--Player-->
		<vb-video-player flex="1" [autoPlay]="autoplay" [durationMs]="video.duration" [hasAudioOnly]="video.hasAudioOnly" [heartbeatIntervalSecs]="video.heartbeatInterval" [hidden]="!video.playbacks" [is360]="video.is360" [isCaptionsAvailable]="video.closedCaptionsEnabled" [live]="video.isLive" [playbacks]="video.playbacks" [playerConfig]="playerConfig" [sourceType]="video.sourceType" [startAt]="startAt" [subtitles]="video.subtitles" [thumbnailUri]="video.thumbnailUri || (video.hasAudioOnly ? '/shared/img/audio-thumbnail.png' : '')" [thumbnailCfg]="video.thumbnailCfg" [timeMarkers]="markers" [videoId]="video.id" [videoTitle]="video.title" (onPlaybackEnded)="onPlaybackEnded()" (onPlayerReady)="onPlayerReady($event.vgAPI, $event.player)">
		</vb-video-player>

		<!--Chapters-->
		<video-chapter-renderer *ngIf="!hideChapters && video.chapterInfo.hasChapters" [hidden]="chapterImagesToggle" [chapterInfo]="video.chapterInfo" [currentTime]="vgAPI?.currentTime || 0" flex="1">
		</video-chapter-renderer>

		<aside class="chapter-image-toggle" [hidden]="hideChapters || !video.chapterInfo.hasChapters">
			<a class="chapter-image-toggler" (click)="chapterImagesToggle = !chapterImagesToggle" [tooltip]="ttTemplate" placement="bottom" container="body">
				<ng-template #ttTemplate>{{ (chapterImagesToggle ? 'Media_Chapters_Show' : 'Media_Chapters_Hide') | translate }}</ng-template>
				<span class="glyphicons font-20" [ngClass]="{
						'eye_close': !chapterImagesToggle,
						'eye_open': chapterImagesToggle
					}">
				</span>
			</a>
		</aside>

	</div>

	<div class="embed-video-unavailable" flex="fill" flex-align="center" flex-justify="center" layout="column" [hidden]="!isVideoUnavailable">

		<div class="embed-video-warning">
			<span class="glyphicons warning_sign"></span>
			{{ 'Media_Videos_Embed_NoLongerAvailable' | translate }}
		</div>

		<button class="btn btn-primary btn-icon-right" type="button" (click)="playNextVideoInPlaylist()" [hidden]="playlist?.videos.length <= 1">
			{{ 'Next' | translate }}
			<span class="glyphicons chevron-right"></span>
		</button>
	</div>

	<!--Playlist-->
	<video-playlist-carousel *ngIf="playlist?.id" [currentVideoId]="video.id" [videos]="playlist.videos" (onSelectionChanged)="onPlaylistSelectionChanged($event)" flex="48px">
	</video-playlist-carousel>
</div>
